import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { useSelector } from 'react-redux';

export const useGetRecentList = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		}
	);

	const userPrefs = useSelector((state) => state.userPrefs.recentlyViewed);
	const recentlyViewed = userPrefs?.[userDetails?.userId] ?? {
		clients: [],
		deals: [],
		claims: [],
	};

	return recentlyViewed;
};
